import { v4 as uuidv4 } from "uuid";
import { FieldProps, GroupProps } from "../../utils/functionsInterfaces";
import { displayError, displayInfo } from "../../utils/messageToast";

export const handleAddPersonalDetailFieldOutsideGroup = (
  form: any,
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  fieldAdd: string,
  setAddFieldPersonalDetails: React.Dispatch<React.SetStateAction<string>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const findFieldInForm = (
    form: (GroupProps | FieldProps)[],
    fieldAdd: string
  ): boolean => {
    return form.some((item: GroupProps | FieldProps) => {
      if ("children" in item) {
        if (item.children && findFieldInForm(item.children, fieldAdd)) {
          return true;
        }
      } else if (item.id === fieldAdd) {
        return true;
      }
      return false;
    });
  };
  const fieldExists = findFieldInForm(form, fieldAdd);

  if (fieldExists) {
    displayError("Campo já existe!");
    setAddFieldPersonalDetails("");
    return;
  }

  if (fieldAdd === "customerSocialNumber") {
    const newField: FieldProps = {
      uuid: uuidv4(),
      id: "customerSocialNumber",
      name: "CPF do cliente",
      type: "field",
      attribute: "",
      settings: {
        detail: "customerSocialNumber",
        placeholder: "Insira o CPF do cliente",
      },
      fieldType: "personal_details",
    };
    setForm((prevForm) => [newField, ...prevForm]);
    setAddFieldPersonalDetails("");
    setButtonSave(true);
    displayInfo("Campo de documento criado!");
  } else if (fieldAdd === "customerPhoneNumber") {
    const newField: FieldProps = {
      uuid: uuidv4(),
      id: "customerPhoneNumber",
      name: "Telefone do cliente",
      type: "field",
      attribute: "",
      settings: {
        detail: "customerPhoneNumber",
        placeholder: "Insira o telefone do cliente.",
      },
      fieldType: "personal_details",
    };
    setForm((prevForm) => [newField, ...prevForm]);
    setAddFieldPersonalDetails("");
    setButtonSave(true);
    displayInfo("Campo de telefone criado!");
  } else if (fieldAdd === "customerEmail") {
    const newField: FieldProps = {
      uuid: uuidv4(),
      id: "customerEmail",
      name: "Email",
      type: "field",
      attribute: "",
      settings: {
        detail: "customerEmail",
        placeholder: "Insira seu Email",
        autofillParam: "mail",
      },
      fieldType: "personal_details",
    };
    setForm((prevForm) => [newField, ...prevForm]);
    setAddFieldPersonalDetails("");
    setButtonSave(true);
    displayInfo("Campo de email criado!");
  } else {
    const newField: FieldProps = {
      uuid: uuidv4(),
      id: "customerName",
      name: "Nome do cliente",
      type: "field",
      attribute: "",
      settings: {
        detail: "customerName",
        placeholder: "Insira o Nome do cliente",
      },
      fieldType: "personal_details",
    };
    setForm((prevForm) => [newField, ...prevForm]);
    setAddFieldPersonalDetails("");
    setButtonSave(true);
    displayInfo("Campo de nome criado!");
  }
};
